import actions from "./actions";

const initState = {
  devices: null,
  schools: null,
  grades: null,
  roles: null,
  users: null,
  key: null,
  summary: null,
};

export default function deviceReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_DEVICES_SUCCESS:
      return {
        ...state,
        devices: action.devices,
      };
    case actions.FETCH_DEVICE_CONFIGS_SUCCESS:
      return {
        ...state,
        schools: action.schools,
        grades: action.grades,
        roles: action.roles,
      };
    case actions.FETCH_DEVICE_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
      };
    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };
    case actions.RESET:
      return {
        ...state,
        devices: null,
      };
    case actions.DEVICES_SUMMARY:
      return {
        ...state,
        summary: action.summary,
      };
    default:
      return state;
  }
}
